import { Button, Tooltip } from '@nextui-org/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaCode } from 'react-icons/fa6';
import Icon from '../base/Icon';
export default function ApiManagerButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === '/api-manager';

  const handleClick = () => {
    navigate('/api-manager');
  };

  return (
    <Tooltip content="Go to API Manager">
      <Button
        isIconOnly
        variant={isActive ? 'solid' : 'flat'}
        color={isActive ? 'primary' : 'primary'}
        className="api-manager-btn"
        onPress={handleClick}
      >
        <Icon icon={FaCode} />
      </Button>
    </Tooltip>
  );
}
